import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import BoardOfAdvisors from "@/pages/BoardOfAdvisors";

export const Route = createFileRoute("/es/sobre-qbd/consejo-asesor")({
  head: () => buildRouteHead("/es/sobre-qbd/consejo-asesor"),
  component: BoardOfAdvisors,
});

